import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddAulaModal from '../Modals/AddAulaModal';
import AddModuloModal from '../Modals/AddModuloModal';
import { formatTime } from '../../../Components/jwtUtils';

const AulasManager = ({ token }) => {
    const [idCurso, setIdCurso] = useState("");
    const [dataModulos, setDataModulos] = useState([]);
    const [showModalAddAula, setShowModalAddAula] = useState(false);
    const [showModalAddModulo, setShowModalAddModulo] = useState(false);
    const [reloadData, setReloadData] = useState(false);
    
    const [file0Selected, setFile0Selected] = useState(false);
    const [file1Selected, setFile1Selected] = useState(false);
    const [file2Selected, setFile2Selected] = useState(false);
    const [moduloAddFile, setModuloAddFile] = useState(false);
    const [uploadAulaProgress, setUploadAulaProgress] = useState(0);

    const {
        register: register_A,
        handleSubmit: handleSubmit_A,
        control: control_A,
        reset: reset_A,
        setValue: setValue_A,
        formState: { errors: errors_A },
    } = useForm();

    const {
        register: register_M,
        handleSubmit: handleSubmit_M,
        control: control_M,
        reset: reset_M,
        setValue: setValue_M,
        formState: { errors: errors_M },
    } = useForm();

    // Efeito para carregar módulos quando um curso é selecionado
    useEffect(() => {
        if (!idCurso) return;
            
        async function fetchModulos() {
            try {
                const response = await Api.get(`api/listar-modulos/${idCurso}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataModulos(response.data);
            } catch (error) {
                console.error(error.response?.data?.message || error);
            }
        }

        fetchModulos();
    }, [token, idCurso, reloadData]);

    const handleKeyPress = (e) => {
        const input = e.target;
        setTimeout(() => {
            input.value = formatTime(input.value);
        }, 0);
    };

    const onSubmitAddAula = async (data) => {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Api.post("/api/novo-aula", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadAulaProgress(percentCompleted + "%");
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadAulaProgress('Aguarde... finalizando...');
                        }, 1000);
                    }
                }
            });

            reset_A();
            setFile0Selected(false);
            setFile1Selected(false);
            setFile2Selected(false);
            setUploadAulaProgress(0);
            setShowModalAddAula(false);

            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error("Erro ao criar nova aula:", error);
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar nova aula"
            };
        }
    };

    const onSubmitAddModulo = async (data) => {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Api.post("/api/novo-modulo", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            reset_M();
            setValue_M("thumbnail", "");
            
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error("Erro ao criar novo módulo:", error);
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar novo módulo"
            };
        }
    };

    const openAddAulaModal = () => {
        setShowModalAddAula(true);
        setUploadAulaProgress(0);
        reset_A();
    };
    
    const openAddModuloModal = () => {
        setShowModalAddModulo(true);
        reset_M();
    };

    const customStyles = {
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#233734",
            "&:hover": {
                borderColor: "#3a6883"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "52px",
            margin: '0px',
            padding: '0px !important',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return {
        openAddAulaModal,
        openAddModuloModal,
        showModalAddAula,
        setShowModalAddAula,
        onSubmitAddAula,
        renderModals: (dataCursos) => (
            <>
                <AddAulaModal
                    showModalAddAula={showModalAddAula}
                    setShowModalAddAula={setShowModalAddAula}
                    setShowModalAddModulo={setShowModalAddModulo}
                    setIdCurso={setIdCurso}
                    idCurso={idCurso}
                    file0Selected={file0Selected}
                    setFile0Selected={setFile0Selected}
                    file1Selected={file1Selected}
                    setFile1Selected={setFile1Selected}
                    file2Selected={file2Selected}
                    setFile2Selected={setFile2Selected}
                    uploadAulaProgress={uploadAulaProgress}
                    register_A={register_A}
                    control_A={control_A}
                    errors_A={errors_A}
                    handleSubmit_A={handleSubmit_A}
                    onSubmitAddAula={onSubmitAddAula}
                    setValue_A={setValue_A}
                    setValue_M={setValue_M}
                    customStyles={customStyles}
                    dataCursos={dataCursos}
                    dataModulos={dataModulos}
                />

                <AddModuloModal
                    showModalAddModulo={showModalAddModulo}
                    setShowModalAddModulo={setShowModalAddModulo}
                    setShowModalAddAula={setShowModalAddAula}
                    setReloadData={setReloadData}
                    reloadData={reloadData}
                    moduloAddFile={moduloAddFile}
                    setModuloAddFile={setModuloAddFile}
                    register_M={register_M}
                    errors_M={errors_M}
                    control_M={control_M}
                    handleSubmit_M={handleSubmit_M}
                    onSubmitAddModulo={onSubmitAddModulo}
                    handleKeyPress={handleKeyPress}
                />
            </>
        )
    };
};

export default AulasManager; 